var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8134 20.2667H10.6934V22.9334H21.8134V20.2667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1999 14.6666H10.8799V17.3333H29.1999V14.6666Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 38H18.9865C8.50648 38 -0.0268555 29.4667 -0.0268555 18.9867C-0.0268555 8.50667 8.53314 0 19.0131 0C29.4931 0 38.0265 8.53333 38.0265 19.0133V36.6933C38.0265 37.44 37.4398 38.0267 36.6931 38.0267L36.6665 38ZM19.0131 2.66667C9.99981 2.66667 2.66648 10 2.66648 19.0133C2.66648 28.0267 9.99981 35.36 19.0131 35.36H35.3598V19.0133C35.3598 10 28.0265 2.66667 19.0131 2.66667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlined);
export default __webpack_public_path__ + "static/media/chat_outlined.7367da363bf1dcd28fa15ce2ce29df50.svg";
export { ForwardRef as ReactComponent };